/* State Imports */

import StateInterface from "../state-interface";

/* Localities Default State Data */

const localities_data: StateInterface["localities"] = {
	_id: "",
	slug: "",
	locality_title: "",
	locality_description: "",
	seo: {
		keywords: [],
		meta_title: "",
		meta_description: "",
	},
	location: {
		title: "",
		coordinates: [],
	},
	images: [],
	price_trends: {
		description: "",
		ppsfs_buy: [],
		ppsfs_rent: [],
	},
	key_highlights: {
		connectivity: "",
		transit: "",
		environment: "",
		vibe: "",
		whats_great_here_pointers: [],
		whats_needs_attention_pointers: [],
	},
	map_description: "",
	vicinity: [],
	faq: [],
	linked_blogs: [],
	created_by: {
		is_business_profile: false,
		user_id: "",
		business_profile_id: "",
		email: "",
	},
	tags: [],
	enabled: false,
	enabled_at: "",
	is_deleted: false,
	deleted_at: "",
	created_at: "",
	updated_at: "",
};

export const localities = localities_data;
export default localities_data;
